import { AccountSelector } from 'modules/account/components/AccountSelector';
import { BalanceMenuButton } from 'modules/layout/components/BalanceMenuButton';
import { Header } from 'modules/layout/const';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { NotificationsMenuButton } from 'modules/layout/components/NotificationsMenuButton';
import {
  ReferralCodeButton,
  useReferralCodeButton,
} from 'modules/referralProgram/components/ReferralCodeButton';
import { SignInButton } from 'modules/auth/components/SignInButton';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useIsSMDown } from 'uiKit/Theme/useTheme';
import { usePartnerClientStatus } from 'domains/jwtToken/hooks/usePartnerClientStatus';

interface HeaderContentProps {
  type?: Header;
}

export const HeaderContent = ({
  type = Header.Default,
}: HeaderContentProps) => {
  const isMobileType = type === Header.Mobile;

  const { isLoggedIn } = useAuth();

  const { isEnterprise } = useAccountStatus();

  const { isPartnerClient } = usePartnerClientStatus();

  const isMobile = useIsSMDown();

  const hasBalanceMenu =
    !isMobileType && isLoggedIn && !isEnterprise && !isPartnerClient;

  const { referralCodeButtonProps } = useReferralCodeButton();

  return (
    <NoSSRGuard fallback={<SignInButton />}>
      {!isMobile && <ReferralCodeButton {...referralCodeButtonProps} />}
      {hasBalanceMenu && <BalanceMenuButton />}
      {!isMobileType && isLoggedIn && <NotificationsMenuButton />}
      {isLoggedIn ? <AccountSelector /> : <SignInButton />}
    </NoSSRGuard>
  );
};
